import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCurrentCoursePath } from '../../location/CurrentCoursePath/selectors';

const courseNavigationSelector = (state) => state.CourseNavigation;

export const selectCourseNavigationByCoursePath = createSelector(
  [courseNavigationSelector],
  (navigations) => {
    return navigations.get('byCoursePath', Immutable.Map());
  }
);

export const makeCourseNavigationSelectorByCoursePath = (coursePath) =>
  createSelector(
    [selectCourseNavigationByCoursePath],
    (courseNavByCoursePath) => {
      return courseNavByCoursePath.get(coursePath, Immutable.Map());
    }
  );

export const makeCourseNavigationMetaSelectorByCoursePath = (coursePath) =>
  createSelector(
    [makeCourseNavigationSelectorByCoursePath(coursePath)],
    (navigationData) => {
      return navigationData.get('meta', Immutable.Map());
    }
  );

export const makeCourseNavigationLinkSelectorByCoursePath = (coursePath) =>
  createSelector(
    [makeCourseNavigationSelectorByCoursePath(coursePath)],
    (navigationData) => {
      return navigationData
        .get('navigations', Immutable.List())
        .filter((navigation) => navigation.get('type') === 'navigation');
    }
  );

export const makeCourseNavigationModuleSetSelectorByCoursePath = (coursePath) =>
  createSelector(
    [makeCourseNavigationSelectorByCoursePath(coursePath)],
    (navigationData) => {
      return navigationData
        .get('navigations', Immutable.List())
        .filter((navigation) => {
          const type = navigation.get('type');
          return type === 'default-module-set' || type === 'module-set';
        });
    }
  );

export const makeCourseNavigationModuleSetSelectorByCurrentCoursePath = createSelector(
  selectCourseNavigationByCoursePath,
  selectCurrentCoursePath,
  (navigationData, coursePath) => {
    return navigationData
      .getIn([coursePath, 'navigations'], Immutable.List())
      .filter((navigation) => {
        const type = navigation.get('type');
        return type === 'default-module-set' || type === 'module-set';
      });
  }
);
